import { QueryClient } from "@tanstack/react-query";

async function throwIfResNotOk(res) {
  if (!res.ok) {
    const text = (await res.text()) || res.statusText;
    throw new Error(`${res.status}: ${text}`);
  }
}

// export async function apiRequest(method, url, data) {
//   const res = await fetch(url, {
//     method,
//     headers: data ? { "Content-Type": "application/json" } : {},
//     body: data ? JSON.stringify(data) : undefined,
//     credentials: "include",
//   });

//   await throwIfResNotOk(res);
//   return res;
// }

export async function apiRequest(method, url, data) {
  try {
    const options = {
      method,
      headers: data ? { "Content-Type": "application/json" } : {},
      body: data ? JSON.stringify(data) : undefined,
      credentials: "include",
    };
   //console.log("API Request Options:", options);
   //console.log("API Request URL:", url);

    const res = await fetch(url, options);
console.log("response", res);

    // Check for non-2xx responses
    await throwIfResNotOk(res);

    // Try parsing JSON response if possible
    const contentType = res.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return await res.json();
    }

    // Return raw text if not JSON
    return await res.text();
  } catch (error) {
    console.error("API Request Error:", error);
    throw error; // re-throw for caller to handle
  }
}


export const getQueryFn = ({ on401: unauthorizedBehavior }) => async ({ queryKey }) => {
  // Fix: Convert queryKey array to proper URL format
  const url = queryKey.join("/");
  const res = await fetch(url, {
    credentials: "include",
  });

  if (unauthorizedBehavior === "returnNull" && res.status === 401) {
    return null;
  }

  await throwIfResNotOk(res);
  return await res.json();
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: getQueryFn({ on401: "throw" }),
      refetchInterval: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      retry: false,
    },
    mutations: {
      retry: false,
    },
  },
});